import create from 'zustand'
import produce from 'immer'
import { persist } from 'zustand/middleware'

export const UserUploadStore = create(
    persist(
        (set) => ({
            uploads: [],
            add: (item = []) => {
                set(
                    produce((draft) => {
                        draft.uploads.unshift(...item)
                    }),
                )
            },
            remove: (number = 1) => {
                set(
                    produce((draft) => {
                        typeof number === 'number'
                            ? draft.uploads.splice(0, number)
                            : draft.uploads.splice(0, 1)
                    }),
                )
            },
            skim: () => {
                set(
                    produce((draft) => {
                        draft.uploads.shift()
                    }),
                )
            },
            reset: () => {
                set({ uploads: [] })
            },
        }),
        {
            name: `olm-user-uploads-${process.env.NEXT_PUBLIC_STORE_SUFFIX}`,
        },
    ),
)
